import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Agent } from '../../../classes/agent';

@Component({
  selector: 'app-connect-social-bar',
  templateUrl: './connect-social-bar.component.html',
  styleUrls: ['./connect-social-bar.component.scss']
})
export class ConnectSocialBarComponent implements OnChanges {
  @Input() web?: string;
  @Input() facebook?: string;
  @Input() twitter?: string;
  @Input() name?: string;
  @Input() pinterest?: string;
  @Input() linkedIn?: string;


  // The web input but ensure that the protocol is in there otherwise the domain gets appended to it
  webWithProtocol: string;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.web) {
      this.webWithProtocol = this.web && this.web.startsWith('http') ? this.web : 'http://' + this.web;
    }
  }

  private _strippedWebLink: string;
  get strippedWebLink(): string {
    // Strip the extra characters like https out
    if (!this._strippedWebLink) {
      this._strippedWebLink = this.web ? this.web.replace(/^\/\/|^.*?:(\/\/)?/, '') : '';
    }
    return this._strippedWebLink;
  }
}
